export default __webpack_public_path__ + "static/media/Blooded Armbands of the Four Winds.99662e3b.jpg";